import { DailyParametersState } from '../../model/DailyParametersState';
import { PassiveParameterTypeEnum } from '../../model/passive/enum/passiveParameterTypeEnum';
import {
  CLEAR_SELECTED_DAILY_PARAMETER,
  FETCH_AVERAGE_WALKING_SPEED,
  FETCH_DAILY_PARAMETER_DATA_SUCCESS,
  FETCH_DAILY_PARAMETER_DATES_SUCCESS,
  FETCH_PASSIVE_PARAMETER_DATA,
} from '../constants/dailyParameterConstants';
import { initialState } from '../system/SystemState';
import { DailyParametersActionTypes } from '../types/dailyParametersActionTypes';

export default function dailyParametersReducer(
  state = initialState.dailyParameters,
  action: DailyParametersActionTypes
): DailyParametersState {
  switch (action.type) {
    case FETCH_DAILY_PARAMETER_DATES_SUCCESS:
      return {
        ...state,
        dates: action.payload,
      };

    case FETCH_DAILY_PARAMETER_DATA_SUCCESS:
      return {
        ...state,
        selectedDailyParameterData: action.payload,
      };
    case FETCH_AVERAGE_WALKING_SPEED:
      return {
        ...state,
        averageWalkingSpeedData: action.payload,
      };
    case FETCH_PASSIVE_PARAMETER_DATA:
      // Handle different parameter types
      if (
        action.payload.parameterType === PassiveParameterTypeEnum.Temperature
      ) {
        return {
          ...state,
          temperatureData: action.payload.data,
          // Also update the maps for consistency
          passiveParameterDataMap: {
            ...state.passiveParameterDataMap,
            [action.payload.parameterType]: action.payload.data,
          },
          passiveParameterData: {
            ...state.passiveParameterData,
            [action.payload.parameterType]: action.payload.data,
          },
        };
      } else if (
        action.payload.parameterType ===
        PassiveParameterTypeEnum.AverageWalkingSpeed
      ) {
        return {
          ...state,
          averageWalkingSpeedData: action.payload.data,
          // Also update the maps for consistency
          passiveParameterDataMap: {
            ...state.passiveParameterDataMap,
            [action.payload.parameterType]: action.payload.data,
          },
          passiveParameterData: {
            ...state.passiveParameterData,
            [action.payload.parameterType]: action.payload.data,
          },
        };
      } else {
        // For other parameter types, store in a map
        return {
          ...state,
          passiveParameterDataMap: {
            ...state.passiveParameterDataMap,
            [action.payload.parameterType]: action.payload.data,
          },
          passiveParameterData: {
            ...state.passiveParameterData,
            [action.payload.parameterType]: action.payload.data,
          },
        };
      }
    case CLEAR_SELECTED_DAILY_PARAMETER:
      return {
        ...state,
        selectedDailyParameterData: [],
      };

    default:
      return state;
  }
}
